
/**
 * @param {*} props - title         = the title of the section, if applicable
 *                  - description   = the description of the section, if applicable
 *                  - narrow        = whether or not the screen is narrow
 *                  - no_background = a flag that hides the grey background of the section
 */
function SubTabSection(props) {

  const sectionTitle = (props.title !== undefined)? (
    <div className='slp-subtab-section-title'>
      {props.title}
    </div>
   ) : null

   const sectionDescription = (props.description !== undefined)? (
    <div className='slp-subtab-section-description'>
      {props.description}
    </div>
   ) : null

   const sectionDetails = (props.title !== undefined || props.description !== undefined)? (
    <div className={'slp-subtab-details' + (props.narrow? '-narrow' : '')}>
      {sectionTitle}
      {sectionDescription}
    </div>
   ) : null;


  return (

    <div className={'slp-subtab-section-container' + (props.narrow? '-narrow' : '')}>

      {sectionDetails}

      <div 
        style={(props.no_background)? {...{backgroundColor: '#00000000'},...{boxShadow: 'none'}} : null}
        className={'slp-subtab-section' + (props.narrow? '-narrow' : '')}
      >
        {props.children}
      </div>

    </div>

  )

}

export default SubTabSection;